import { gql } from '@apollo/client';

export const DUALMATCH = gql`
  query dualMatch($id: ID!) {
    dualMatch(id: $id) {
      id
      contextualInfo {
        result
        didWin
        homeTeam
        thisTeam {
          name
          id
        }
        opponent {
          name
          id
        }
      }
      startDateTime {
        timezoneName
        noScheduledTime
        dateTimeString
      }
      homeTeam {
        name
        id
        sideNumber
      }
      teams {
        name
        id
        score
        sideNumber
        division
        conference
        logo {
          url
          width
        }
        abbreviation
      }
      location
      scoringFormat
      isConferenceMatch
      isNeutralLocation
      doublesOrderFinish {
        orderOfFinish
        matchUpId
      }
      singlesOrderFinish {
        orderOfFinish
        matchUpId
      }
      tieMatchUps {
        id
        type
        status
        side1 {
          participants {
            firstName
            lastName
            personId
          }
          score {
            scoreString
            sets {
              setScore
              tiebreakScore
              tiebreakSet
              didWin
            }
          }
          teamAbbreviation
          didWin
        }
        side2 {
          participants {
            firstName
            lastName
            personId
          }
          score {
            scoreString
            sets {
              setScore
              tiebreakScore
              tiebreakSet
              didWin
            }
          }
          teamAbbreviation
          didWin
        }
        collectionPosition
        collectionId
      }
    }
  }
`;
